import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'aog-spell-check-suggestions',
  templateUrl: './spell-check-suggestions.component.html',
  styleUrls: ['./spell-check-suggestions.component.scss']
})
export class SpellCheckSuggestionsComponent {
  @Input() word: string = '';
  @Input() suggestions: string[] = [];
  @Output() onSuggestionClick = new EventEmitter<string>();

  selectSuggestion(suggestion: string): void {
    this.onSuggestionClick.emit(suggestion);
  }
}

